<template>
  <div class="bg-white rounded rounded-5 text-center p-3 shadow">
    <b-row class="mb-4">
      <b-col class="text-center">
        <h5> {{ item.timable.name }} ({{ TimingFilters[item.timable_type.toUpperCase()].label }}) </h5>
      </b-col>
    </b-row>

    <b-row class="my-3">
      <b-col lg="6">
        <p>
          شروع:
          <span dir="ltr" class="font-weight-bolder">{{ dateFormat(item.open_at) }}</span>
        </p>
      </b-col>

      <b-col lg="6">
        <p>
          پایان:
          <span dir="ltr" class="font-weight-bolder">{{ dateFormat(item.close_at) }}</span>
        </p>
      </b-col>
    </b-row>


    <b-row class="d-flex my-3 px-2 flex-row justify-content-center">
      <span>تا پایان زمان بندی </span>
      <span class="mx-1 font-weight-bolder"> {{ timeRemained.days }} روز</span>
      <span class="mx-1 font-weight-bolder"> {{ timeRemained.hours }} ساعت</span>
      <span class="mx-1 font-weight-bolder"> {{ timeRemained.minutes }} دقیقه</span>
      <span class="mx-1 font-weight-bolder"> {{ timeRemained.seconds }} ثانیه</span>
      <span>باقی مانده است.</span>
    </b-row>


    <b-row class="">
      <b-col cols="6">
        <b-icon-trash @click="removeTiming()" class="h5"/>
      </b-col>
      <b-col cols="6">
        <b-icon-pencil v-b-modal="`update-item-${item.id}`" class="h5"/>
      </b-col>
    </b-row>


    <b-modal :id="`update-item-${item.id}`" hide-footer size="lg">
      <create-form :page="page" :filters="filters" :item="item"/>
    </b-modal>

  </div>
</template>

<script>
import {getTimeRemained} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Timing";
import {dateConverter} from '@moeinmdn/mixitweb-front-modules/src/plugin/class/Converter'
import {
  TimingFilters,
} from "@moeinmdn/mixitweb-front-modules/src/plugin/Modules/Timing";
import CreateForm from "./CreateForm";

export default {
  name: "TimingCard",
  components: {CreateForm},
  props: ['item', 'filters', 'page'],
  data() {
    return {
      TimingFilters
    }
  },
  computed: {
    timeRemained() {
      return getTimeRemained(this.item.open_at, this.item.close_at)
    },
  },
  methods: {
    dateConverter,
    async removeTiming() {
      if (confirm('ایا از حذف زمان بندی اطمینان دارید؟')) {
        await this.$store.dispatch("Timing/removeTiming", {id: this.item.id})
        await this.$store.dispatch('Timing/getTimings', {page: this.page, form: this.filters})
      }
    },
    dateFormat(date) {
      return this.dateConverter(date, '/', true)
    },
  }
}
</script>

<style scoped>

</style>